.trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: var(--text-primary);
  font-size: 16px;
  cursor: pointer;
}

.trigger:hover {
  background: var(--light-gray);
}

.trigger:focus-visible {
  outline: 2px solid var(--light-blue);
  outline-offset: 2px;
}

.menu {
  width: 232px;
}

.label {
  white-space: nowrap;
}
